// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AvatarCircle-module__font-s-10___zMSHp {
  font-size: 10px !important;
}

.AvatarCircle-module__font-s-12___YEHhW {
  font-size: 12px !important;
}

.AvatarCircle-module__font-s-13___DxZgf {
  font-size: 13px !important;
}

.AvatarCircle-module__font-s-14___FhsLZ {
  font-size: 14px !important;
}

.AvatarCircle-module__font-s-15___BJ94X {
  font-size: 15px !important;
}

.AvatarCircle-module__font-s-16___gPNjK {
  font-size: 16px !important;
}

.AvatarCircle-module__font-s-18___c9yEa {
  font-size: 18px !important;
}

.AvatarCircle-module__font-s-20___B6KKD {
  font-size: 20px !important;
}

.AvatarCircle-module__font-s-22___LwdyR {
  font-size: 22px !important;
}

.AvatarCircle-module__font-s-28___JeY6S {
  font-size: 28px !important;
}

.AvatarCircle-module__font-w-400___wKdzv {
  font-weight: 400 !important;
}

.AvatarCircle-module__font-w-500___OMh68 {
  font-weight: 500 !important;
}

.AvatarCircle-module__font-w-600___iohFy {
  font-weight: 600 !important;
}

.AvatarCircle-module__font-w-700___RD8Nx {
  font-weight: 700 !important;
}

.AvatarCircle-module__p-5___e7WCl {
  padding: 5px !important;
}

.AvatarCircle-module__p-12____Bv1q {
  padding: 12px !important;
}

.AvatarCircle-module__p-16___to42r {
  padding: 16px !important;
}

.AvatarCircle-module__p-30___fGhJu {
  padding: 30px !important;
}

.AvatarCircle-module__p-b-0___c40et {
  padding-bottom: 0 !important;
}

.AvatarCircle-module__p-b-5___u_c4i {
  padding-bottom: 5px !important;
}

.AvatarCircle-module__p-b-10___yu2c8 {
  padding-bottom: 10px !important;
}

.AvatarCircle-module__p-b-12___CBkk0 {
  padding-bottom: 12px !important;
}

.AvatarCircle-module__p-b-16___FeKcE {
  padding-bottom: 16px !important;
}

.AvatarCircle-module__p-b-18___SRsHf {
  padding-bottom: 18px !important;
}

.AvatarCircle-module__p-b-20___ZOnbf {
  padding-bottom: 20px !important;
}

.AvatarCircle-module__p-b-25___z0fh1 {
  padding-bottom: 25px !important;
}

.AvatarCircle-module__p-b-30___ebpd_ {
  padding-bottom: 30px !important;
}

.AvatarCircle-module__p-b-50___ZYKJq {
  padding-bottom: 50px !important;
}

.AvatarCircle-module__p-t-0___Kd0vF {
  padding-top: 0 !important;
}

.AvatarCircle-module__p-t-12___XL9H4 {
  padding-top: 12px !important;
}

.AvatarCircle-module__p-t-16___XcMHD {
  padding-top: 16px !important;
}

.AvatarCircle-module__p-t-18___kWlo7 {
  padding-top: 18px !important;
}

.AvatarCircle-module__p-t-20___gP3kV {
  padding-top: 20px !important;
}

.AvatarCircle-module__p-t-30___DhGYf {
  padding-top: 30px !important;
}

.AvatarCircle-module__p-t-40___v61v2 {
  padding-top: 40px !important;
}

.AvatarCircle-module__p-t-50___Ylc7r {
  padding-top: 50px !important;
}

.AvatarCircle-module__p-l-20___nB6Lx {
  padding-left: 20px !important;
}

.AvatarCircle-module__p-l-30___hB8Gn {
  padding-left: 30px !important;
}

.AvatarCircle-module__p-l-40___MVLvE {
  padding-left: 40px !important;
}

.AvatarCircle-module__p-r-16___YtjLc {
  padding-right: 16px !important;
}

.AvatarCircle-module__p-r-20___zknV_ {
  padding-right: 20px !important;
}

.AvatarCircle-module__p-r-30___O2DVk {
  padding-right: 30px !important;
}

.AvatarCircle-module__p-r-50___lteBT {
  padding-right: 50px !important;
}

.AvatarCircle-module__p-r-60___ioI5O {
  padding-right: 60px !important;
}

.AvatarCircle-module__m-b-1___WBVHa {
  margin-bottom: 1px !important;
}

.AvatarCircle-module__m-b-2___q1VJX {
  margin-bottom: 2px !important;
}

.AvatarCircle-module__m-b-6___t0K7F {
  margin-bottom: 6px !important;
}

.AvatarCircle-module__m-b-8___hKo1e {
  margin-bottom: 8px !important;
}

.AvatarCircle-module__m-b-10___snhLu {
  margin-bottom: 10px !important;
}

.AvatarCircle-module__m-b-14___heQKg {
  margin-bottom: 14px !important;
}

.AvatarCircle-module__m-b-16___T2Wvq {
  margin-bottom: 16px !important;
}

.AvatarCircle-module__m-b-20___gj_DH {
  margin-bottom: 20px !important;
}

.AvatarCircle-module__m-b-22___LNGpe {
  margin-bottom: 22px !important;
}

.AvatarCircle-module__m-b-24___QQ6KF {
  margin-bottom: 24px !important;
}

.AvatarCircle-module__m-b-30___QS1Aw {
  margin-bottom: 30px !important;
}

.AvatarCircle-module__m-b-32___y71j6 {
  margin-bottom: 32px !important;
}

.AvatarCircle-module__m-b-40___unkrI {
  margin-bottom: 40px !important;
}

.AvatarCircle-module__m-t-2___mj0QS {
  margin-top: 2px !important;
}

.AvatarCircle-module__m-t-3___bK9Uy {
  margin-top: 3px !important;
}

.AvatarCircle-module__m-t-4___N3xjm {
  margin-top: 4px !important;
}

.AvatarCircle-module__m-t-5___ipRTN {
  margin-top: 5px !important;
}

.AvatarCircle-module__m-t-8___LXYPe {
  margin-top: 8px !important;
}

.AvatarCircle-module__m-t-10___WoJeu {
  margin-top: 10px !important;
}

.AvatarCircle-module__m-t-15___BjEZC {
  margin-top: 15px !important;
}

.AvatarCircle-module__m-t-16___EY9uS {
  margin-top: 16px !important;
}

.AvatarCircle-module__m-t-20___detAR {
  margin-top: 20px !important;
}

.AvatarCircle-module__m-t-22___SN15e {
  margin-top: 22px !important;
}

.AvatarCircle-module__m-t-30___LGUBN {
  margin-top: 30px !important;
}

.AvatarCircle-module__m-t-32___k6qcP {
  margin-top: 32px !important;
}

.AvatarCircle-module__m-l-auto___BQ1Lp {
  margin-left: auto !important;
}

.AvatarCircle-module__m-l-4___SG2bY {
  margin-left: 4px !important;
}

.AvatarCircle-module__m-l-5___fx9Zp {
  margin-left: 5px !important;
}

.AvatarCircle-module__m-l-6___xKAMu {
  margin-left: 6px !important;
}

.AvatarCircle-module__m-l-8___ZYeR1 {
  margin-left: 8px !important;
}

.AvatarCircle-module__m-l-10___GFAy2 {
  margin-left: 10px !important;
}

.AvatarCircle-module__m-l-16___VX9mK {
  margin-left: 16px !important;
}

.AvatarCircle-module__m-l-20___gsWKm {
  margin-left: 20px !important;
}

.AvatarCircle-module__m-l-24___IZ5uS {
  margin-left: 24px !important;
}

.AvatarCircle-module__m-l-30___IM3VE {
  margin-left: 30px !important;
}

.AvatarCircle-module__m-l-35___DYvVW {
  margin-left: 35px !important;
}

.AvatarCircle-module__m-l-40___pJCgg {
  margin-left: 40px !important;
}

.AvatarCircle-module__m-r-8___l718v {
  margin-right: 8px !important;
}

.AvatarCircle-module__m-r-10___VeWHZ {
  margin-right: 10px !important;
}

.AvatarCircle-module__m-r-16___xKXmE {
  margin-right: 16px !important;
}

.AvatarCircle-module__m-r-20___iS0rk {
  margin-right: 20px !important;
}

.AvatarCircle-module__m-r-24___ikrZu {
  margin-right: 24px !important;
}

.AvatarCircle-module__m-r-30___stnFH {
  margin-right: 30px !important;
}

.AvatarCircle-module__m-r-40___ApYtS {
  margin-right: 40px !important;
}

.AvatarCircle-module__border-r-3___v0D4w {
  border-radius: 3px !important;
}

.AvatarCircle-module__border-r-4___unfW5 {
  border-radius: 4px !important;
}

.AvatarCircle-module__border-r-6___KkEe2 {
  border-radius: 6px !important;
}

.AvatarCircle-module__border-r-10___GDea_ {
  border-radius: 10px !important;
}

.AvatarCircle-module__border-r-12___atJbw {
  border-radius: 12px !important;
}

.AvatarCircle-module__border-r-16___TlTaj {
  border-radius: 16px !important;
}

.AvatarCircle-module__border-r-50___aqKcY {
  border-radius: 50% !important;
}

.AvatarCircle-module__primary-border___asqwz {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.AvatarCircle-module__primary-border-b___q9TCe {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.AvatarCircle-module__primary-border-t___B5607 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.AvatarCircle-module__primary-border-l___zTfR4 {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.AvatarCircle-module__primary-border-r___PuRFh {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.AvatarCircle-module__secondary-border___x7bcB {
  border: 1px solid #637768;
}

.AvatarCircle-module__secondary-border-b___pAwZ8 {
  border-bottom: 1px solid #637768;
}

.AvatarCircle-module__secondary-border-t___LAel_ {
  border-top: 1px solid #637768;
}

.AvatarCircle-module__secondary-border-l___joXLt {
  border-left: 1px solid #637768;
}

.AvatarCircle-module__secondary-border-r___o3Xem {
  border-right: 1px solid #637768;
}

.AvatarCircle-module__gap-0___tfCnZ {
  gap: 0 !important;
}

.AvatarCircle-module__gap-2___jSWHW {
  gap: 2px !important;
}

.AvatarCircle-module__gap-4___WIZYk {
  gap: 4px !important;
}

.AvatarCircle-module__gap-5___gipPm {
  gap: 5px !important;
}

.AvatarCircle-module__gap-6___tJgr2 {
  gap: 6px !important;
}

.AvatarCircle-module__gap-8___iFyil {
  gap: 8px !important;
}

.AvatarCircle-module__gap-10___Fn4tU {
  gap: 10px !important;
}

.AvatarCircle-module__gap-12___IHlXo {
  gap: 12px !important;
}

.AvatarCircle-module__gap-14___DKS7I {
  gap: 14px !important;
}

.AvatarCircle-module__gap-16___QqIR7 {
  gap: 16px !important;
}

.AvatarCircle-module__gap-18___RtHRn {
  gap: 18px !important;
}

.AvatarCircle-module__gap-20___Mjjc1 {
  gap: 20px !important;
}

.AvatarCircle-module__gap-24___ntIHp {
  gap: 24px !important;
}

.AvatarCircle-module__gap-26___oM2L5 {
  gap: 26px !important;
}

.AvatarCircle-module__gap-30___aDDaP {
  gap: 30px !important;
}

.AvatarCircle-module__gap-32___J4Ht9 {
  gap: 32px !important;
}

.AvatarCircle-module__gap-40___pY_c1 {
  gap: 40px !important;
}

.AvatarCircle-module__gap-50___c_GUR {
  gap: 50px !important;
}

.AvatarCircle-module__flex-1___HrXeO {
  flex: 1;
}

.AvatarCircle-module__flex-none___iEruO {
  flex: none !important;
}

.AvatarCircle-module__flex-column___jGuZ5 {
  display: flex;
  flex-direction: column !important;
}

.AvatarCircle-module__flex-row___KDc8r {
  display: flex;
  flex-direction: row !important;
}

.AvatarCircle-module__vertically-centered___BlP8B {
  display: flex;
  align-items: center !important;
}

.AvatarCircle-module__horizontally-centered___CTDWN {
  display: flex;
  justify-content: center !important;
}

.AvatarCircle-module__horizontally-end___AC0v1 {
  display: flex;
  justify-content: end !important;
}

.AvatarCircle-module__vertically-start___DlJaO {
  display: flex;
  align-items: start !important;
}

.AvatarCircle-module__space-between___LDszB {
  display: flex;
  justify-content: space-between !important;
}

.AvatarCircle-module__flex-wrap___sf9mX {
  flex-wrap: wrap !important;
}

.AvatarCircle-module__height-100___uNGZi {
  height: 100%;
}

.AvatarCircle-module__width-50___nlG1Z {
  width: 50% !important;
}

.AvatarCircle-module__width-100___OADch {
  width: 100%;
}

.AvatarCircle-module__cursor-pointer___JT4Hj {
  cursor: pointer;
}

.AvatarCircle-module__cursor-not-allowed___iESFG {
  cursor: not-allowed !important;
}

.AvatarCircle-module__absolute-centered___Fqlja {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.AvatarCircle-module__absolute___on3QM {
  position: absolute;
}

.AvatarCircle-module__relative___K61JD {
  position: relative;
}

.AvatarCircle-module__fixed___Do3sB {
  position: fixed;
}

.AvatarCircle-module__visible___szOf3 {
  opacity: 1;
}

.AvatarCircle-module__invisible___d7BRi {
  opacity: 0;
}

.AvatarCircle-module__col-90___bhOgv {
  width: 90% !important;
}

.AvatarCircle-module__col-auto___laIVy {
  width: auto !important;
}

.AvatarCircle-module__medical-tabs___trOeq {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.AvatarCircle-module__medical-table-new___w89A4 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AvatarCircle-module__medical-table-new___w89A4:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AvatarCircle-module__medical-table-new___w89A4::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AvatarCircle-module__medical-table-new___w89A4::-webkit-scrollbar-track {
  display: none;
}
.AvatarCircle-module__medical-table-new___w89A4.AvatarCircle-module__no-pagination___s5hEz {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.AvatarCircle-module__medical-table-new___w89A4.AvatarCircle-module__no-pagination___s5hEz:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.AvatarCircle-module__medical-table-new___w89A4.AvatarCircle-module__no-pagination___s5hEz::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.AvatarCircle-module__medical-table-new___w89A4.AvatarCircle-module__no-pagination___s5hEz::-webkit-scrollbar-track {
  display: none;
}

.AvatarCircle-module__medical-table-empty___h6s8v {
  padding: 14px 40px !important;
}

.AvatarCircle-module__icon-btn___xTT05 {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.AvatarCircle-module__search-icon___hDWHb {
  width: 24px;
  height: 24px;
  align-self: center;
}

.AvatarCircle-module__disable-select___N50ZE {
  user-select: none;
}

.AvatarCircle-module__break-word___Uh9rO {
  word-break: break-word;
}

.AvatarCircle-module__popup-clear-btn___VieMH {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.AvatarCircle-module__scroll-m-b-20___NgkYQ {
  scroll-margin-bottom: 20px;
}

.AvatarCircle-module__circularView____fedy {
  position: relative;
}

.AvatarCircle-module__regular___i6E4p {
  width: 29px;
  min-width: 29px;
  height: 29px;
  min-height: 29px;
}

.AvatarCircle-module__large___UeAh6 {
  width: 36px;
  min-width: 36px;
  height: 36px;
  min-height: 36px;
}

.AvatarCircle-module__imageIcon___ciVkD {
  position: absolute;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.AvatarCircle-module__imageIcon___ciVkD.AvatarCircle-module__avatarImg___MxHDn {
  width: 90%;
  height: 90%;
}

.AvatarCircle-module__personIcon___UsVVk {
  width: 100%;
  object-fit: contain;
  filter: invert(0.65);
}

.AvatarCircle-module__userText___Ytsjb {
  width: 100%;
  height: 100%;
  color: white;
  background: #0091ff;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/elements/AvatarCircle/AvatarCircle.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,kBAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,gBAAA;AA8pBF;;AA3pBA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;AA8pBF;AA5pBE;EACE,UAAA;EACA,WAAA;AA8pBJ;;AA1pBA;EACE,WAAA;EACA,mBAAA;EACA,oBAAA;AA6pBF;;AA1pBA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;AA6pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.circularView {\n  position: relative;\n}\n\n.regular {\n  width: 29px;\n  min-width: 29px;\n  height: 29px;\n  min-height: 29px;\n}\n\n.large {\n  width: 36px;\n  min-width: 36px;\n  height: 36px;\n  min-height: 36px;\n}\n\n.imageIcon {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n\n  &.avatarImg {\n    width: 90%;\n    height: 90%;\n  }\n}\n\n.personIcon {\n  width: 100%;\n  object-fit: contain;\n  filter: invert(0.65);\n}\n\n.userText {\n  width: 100%;\n  height: 100%;\n  color: get-color(white);\n  background: get-color(blue);\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `AvatarCircle-module__font-s-10___zMSHp`,
	"fontS12": `AvatarCircle-module__font-s-12___YEHhW`,
	"fontS13": `AvatarCircle-module__font-s-13___DxZgf`,
	"fontS14": `AvatarCircle-module__font-s-14___FhsLZ`,
	"fontS15": `AvatarCircle-module__font-s-15___BJ94X`,
	"fontS16": `AvatarCircle-module__font-s-16___gPNjK`,
	"fontS18": `AvatarCircle-module__font-s-18___c9yEa`,
	"fontS20": `AvatarCircle-module__font-s-20___B6KKD`,
	"fontS22": `AvatarCircle-module__font-s-22___LwdyR`,
	"fontS28": `AvatarCircle-module__font-s-28___JeY6S`,
	"fontW400": `AvatarCircle-module__font-w-400___wKdzv`,
	"fontW500": `AvatarCircle-module__font-w-500___OMh68`,
	"fontW600": `AvatarCircle-module__font-w-600___iohFy`,
	"fontW700": `AvatarCircle-module__font-w-700___RD8Nx`,
	"p5": `AvatarCircle-module__p-5___e7WCl`,
	"p12": `AvatarCircle-module__p-12____Bv1q`,
	"p16": `AvatarCircle-module__p-16___to42r`,
	"p30": `AvatarCircle-module__p-30___fGhJu`,
	"pB0": `AvatarCircle-module__p-b-0___c40et`,
	"pB5": `AvatarCircle-module__p-b-5___u_c4i`,
	"pB10": `AvatarCircle-module__p-b-10___yu2c8`,
	"pB12": `AvatarCircle-module__p-b-12___CBkk0`,
	"pB16": `AvatarCircle-module__p-b-16___FeKcE`,
	"pB18": `AvatarCircle-module__p-b-18___SRsHf`,
	"pB20": `AvatarCircle-module__p-b-20___ZOnbf`,
	"pB25": `AvatarCircle-module__p-b-25___z0fh1`,
	"pB30": `AvatarCircle-module__p-b-30___ebpd_`,
	"pB50": `AvatarCircle-module__p-b-50___ZYKJq`,
	"pT0": `AvatarCircle-module__p-t-0___Kd0vF`,
	"pT12": `AvatarCircle-module__p-t-12___XL9H4`,
	"pT16": `AvatarCircle-module__p-t-16___XcMHD`,
	"pT18": `AvatarCircle-module__p-t-18___kWlo7`,
	"pT20": `AvatarCircle-module__p-t-20___gP3kV`,
	"pT30": `AvatarCircle-module__p-t-30___DhGYf`,
	"pT40": `AvatarCircle-module__p-t-40___v61v2`,
	"pT50": `AvatarCircle-module__p-t-50___Ylc7r`,
	"pL20": `AvatarCircle-module__p-l-20___nB6Lx`,
	"pL30": `AvatarCircle-module__p-l-30___hB8Gn`,
	"pL40": `AvatarCircle-module__p-l-40___MVLvE`,
	"pR16": `AvatarCircle-module__p-r-16___YtjLc`,
	"pR20": `AvatarCircle-module__p-r-20___zknV_`,
	"pR30": `AvatarCircle-module__p-r-30___O2DVk`,
	"pR50": `AvatarCircle-module__p-r-50___lteBT`,
	"pR60": `AvatarCircle-module__p-r-60___ioI5O`,
	"mB1": `AvatarCircle-module__m-b-1___WBVHa`,
	"mB2": `AvatarCircle-module__m-b-2___q1VJX`,
	"mB6": `AvatarCircle-module__m-b-6___t0K7F`,
	"mB8": `AvatarCircle-module__m-b-8___hKo1e`,
	"mB10": `AvatarCircle-module__m-b-10___snhLu`,
	"mB14": `AvatarCircle-module__m-b-14___heQKg`,
	"mB16": `AvatarCircle-module__m-b-16___T2Wvq`,
	"mB20": `AvatarCircle-module__m-b-20___gj_DH`,
	"mB22": `AvatarCircle-module__m-b-22___LNGpe`,
	"mB24": `AvatarCircle-module__m-b-24___QQ6KF`,
	"mB30": `AvatarCircle-module__m-b-30___QS1Aw`,
	"mB32": `AvatarCircle-module__m-b-32___y71j6`,
	"mB40": `AvatarCircle-module__m-b-40___unkrI`,
	"mT2": `AvatarCircle-module__m-t-2___mj0QS`,
	"mT3": `AvatarCircle-module__m-t-3___bK9Uy`,
	"mT4": `AvatarCircle-module__m-t-4___N3xjm`,
	"mT5": `AvatarCircle-module__m-t-5___ipRTN`,
	"mT8": `AvatarCircle-module__m-t-8___LXYPe`,
	"mT10": `AvatarCircle-module__m-t-10___WoJeu`,
	"mT15": `AvatarCircle-module__m-t-15___BjEZC`,
	"mT16": `AvatarCircle-module__m-t-16___EY9uS`,
	"mT20": `AvatarCircle-module__m-t-20___detAR`,
	"mT22": `AvatarCircle-module__m-t-22___SN15e`,
	"mT30": `AvatarCircle-module__m-t-30___LGUBN`,
	"mT32": `AvatarCircle-module__m-t-32___k6qcP`,
	"mLAuto": `AvatarCircle-module__m-l-auto___BQ1Lp`,
	"mL4": `AvatarCircle-module__m-l-4___SG2bY`,
	"mL5": `AvatarCircle-module__m-l-5___fx9Zp`,
	"mL6": `AvatarCircle-module__m-l-6___xKAMu`,
	"mL8": `AvatarCircle-module__m-l-8___ZYeR1`,
	"mL10": `AvatarCircle-module__m-l-10___GFAy2`,
	"mL16": `AvatarCircle-module__m-l-16___VX9mK`,
	"mL20": `AvatarCircle-module__m-l-20___gsWKm`,
	"mL24": `AvatarCircle-module__m-l-24___IZ5uS`,
	"mL30": `AvatarCircle-module__m-l-30___IM3VE`,
	"mL35": `AvatarCircle-module__m-l-35___DYvVW`,
	"mL40": `AvatarCircle-module__m-l-40___pJCgg`,
	"mR8": `AvatarCircle-module__m-r-8___l718v`,
	"mR10": `AvatarCircle-module__m-r-10___VeWHZ`,
	"mR16": `AvatarCircle-module__m-r-16___xKXmE`,
	"mR20": `AvatarCircle-module__m-r-20___iS0rk`,
	"mR24": `AvatarCircle-module__m-r-24___ikrZu`,
	"mR30": `AvatarCircle-module__m-r-30___stnFH`,
	"mR40": `AvatarCircle-module__m-r-40___ApYtS`,
	"borderR3": `AvatarCircle-module__border-r-3___v0D4w`,
	"borderR4": `AvatarCircle-module__border-r-4___unfW5`,
	"borderR6": `AvatarCircle-module__border-r-6___KkEe2`,
	"borderR10": `AvatarCircle-module__border-r-10___GDea_`,
	"borderR12": `AvatarCircle-module__border-r-12___atJbw`,
	"borderR16": `AvatarCircle-module__border-r-16___TlTaj`,
	"borderR50": `AvatarCircle-module__border-r-50___aqKcY`,
	"primaryBorder": `AvatarCircle-module__primary-border___asqwz`,
	"primaryBorderB": `AvatarCircle-module__primary-border-b___q9TCe`,
	"primaryBorderT": `AvatarCircle-module__primary-border-t___B5607`,
	"primaryBorderL": `AvatarCircle-module__primary-border-l___zTfR4`,
	"primaryBorderR": `AvatarCircle-module__primary-border-r___PuRFh`,
	"secondaryBorder": `AvatarCircle-module__secondary-border___x7bcB`,
	"secondaryBorderB": `AvatarCircle-module__secondary-border-b___pAwZ8`,
	"secondaryBorderT": `AvatarCircle-module__secondary-border-t___LAel_`,
	"secondaryBorderL": `AvatarCircle-module__secondary-border-l___joXLt`,
	"secondaryBorderR": `AvatarCircle-module__secondary-border-r___o3Xem`,
	"gap0": `AvatarCircle-module__gap-0___tfCnZ`,
	"gap2": `AvatarCircle-module__gap-2___jSWHW`,
	"gap4": `AvatarCircle-module__gap-4___WIZYk`,
	"gap5": `AvatarCircle-module__gap-5___gipPm`,
	"gap6": `AvatarCircle-module__gap-6___tJgr2`,
	"gap8": `AvatarCircle-module__gap-8___iFyil`,
	"gap10": `AvatarCircle-module__gap-10___Fn4tU`,
	"gap12": `AvatarCircle-module__gap-12___IHlXo`,
	"gap14": `AvatarCircle-module__gap-14___DKS7I`,
	"gap16": `AvatarCircle-module__gap-16___QqIR7`,
	"gap18": `AvatarCircle-module__gap-18___RtHRn`,
	"gap20": `AvatarCircle-module__gap-20___Mjjc1`,
	"gap24": `AvatarCircle-module__gap-24___ntIHp`,
	"gap26": `AvatarCircle-module__gap-26___oM2L5`,
	"gap30": `AvatarCircle-module__gap-30___aDDaP`,
	"gap32": `AvatarCircle-module__gap-32___J4Ht9`,
	"gap40": `AvatarCircle-module__gap-40___pY_c1`,
	"gap50": `AvatarCircle-module__gap-50___c_GUR`,
	"flex1": `AvatarCircle-module__flex-1___HrXeO`,
	"flexNone": `AvatarCircle-module__flex-none___iEruO`,
	"flexColumn": `AvatarCircle-module__flex-column___jGuZ5`,
	"flexRow": `AvatarCircle-module__flex-row___KDc8r`,
	"verticallyCentered": `AvatarCircle-module__vertically-centered___BlP8B`,
	"horizontallyCentered": `AvatarCircle-module__horizontally-centered___CTDWN`,
	"horizontallyEnd": `AvatarCircle-module__horizontally-end___AC0v1`,
	"verticallyStart": `AvatarCircle-module__vertically-start___DlJaO`,
	"spaceBetween": `AvatarCircle-module__space-between___LDszB`,
	"flexWrap": `AvatarCircle-module__flex-wrap___sf9mX`,
	"height100": `AvatarCircle-module__height-100___uNGZi`,
	"width50": `AvatarCircle-module__width-50___nlG1Z`,
	"width100": `AvatarCircle-module__width-100___OADch`,
	"cursorPointer": `AvatarCircle-module__cursor-pointer___JT4Hj`,
	"cursorNotAllowed": `AvatarCircle-module__cursor-not-allowed___iESFG`,
	"absoluteCentered": `AvatarCircle-module__absolute-centered___Fqlja`,
	"absolute": `AvatarCircle-module__absolute___on3QM`,
	"relative": `AvatarCircle-module__relative___K61JD`,
	"fixed": `AvatarCircle-module__fixed___Do3sB`,
	"visible": `AvatarCircle-module__visible___szOf3`,
	"invisible": `AvatarCircle-module__invisible___d7BRi`,
	"col90": `AvatarCircle-module__col-90___bhOgv`,
	"colAuto": `AvatarCircle-module__col-auto___laIVy`,
	"medicalTabs": `AvatarCircle-module__medical-tabs___trOeq`,
	"medicalTableNew": `AvatarCircle-module__medical-table-new___w89A4`,
	"noPagination": `AvatarCircle-module__no-pagination___s5hEz`,
	"medicalTableEmpty": `AvatarCircle-module__medical-table-empty___h6s8v`,
	"iconBtn": `AvatarCircle-module__icon-btn___xTT05`,
	"searchIcon": `AvatarCircle-module__search-icon___hDWHb`,
	"disableSelect": `AvatarCircle-module__disable-select___N50ZE`,
	"breakWord": `AvatarCircle-module__break-word___Uh9rO`,
	"popupClearBtn": `AvatarCircle-module__popup-clear-btn___VieMH`,
	"scrollMB20": `AvatarCircle-module__scroll-m-b-20___NgkYQ`,
	"circularView": `AvatarCircle-module__circularView____fedy`,
	"regular": `AvatarCircle-module__regular___i6E4p`,
	"large": `AvatarCircle-module__large___UeAh6`,
	"imageIcon": `AvatarCircle-module__imageIcon___ciVkD`,
	"avatarImg": `AvatarCircle-module__avatarImg___MxHDn`,
	"personIcon": `AvatarCircle-module__personIcon___UsVVk`,
	"userText": `AvatarCircle-module__userText___Ytsjb`
};
module.exports = ___CSS_LOADER_EXPORT___;
